import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import FormControl from '@material-ui/core/FormControl';
import React from 'react';
import { ConjsProps } from 'react-awesome-query-builder';

import { publicaColors } from '~/src/dash/utils/colors';

export default (props: ConjsProps) => {
  const { not, setNot, conjunctionOptions, setConjunction, disabled, readonly, showNot, notLabel } =
    props;

  // TIP: disabled=true if only 1 rule; readonly=true if immutable mode
  const conjsCount = conjunctionOptions ? Object.keys(conjunctionOptions).length : 0;
  const lessThenTwo = disabled;

  const enabledStyle = { backgroundColor: '#4952FF' };
  const disabledStyle = {
    backgroundColor: publicaColors.lightGray,
    color: publicaColors.mediumGray,
  };

  const onClick = (value: string) => setConjunction(value);
  const onNotClick = (checked: boolean) => setNot(checked);

  const renderOptions = () => {
    if (!conjunctionOptions) {
      return <></>;
    }

    return Object.keys(conjunctionOptions).map((key) => {
      const { id, label, checked } = conjunctionOptions[key];
      if (readonly && !checked) {
        return null;
      }
      return (
        <Button
          key={id}
          id={id}
          color={checked ? 'primary' : 'default'}
          variant={checked ? 'contained' : 'text'}
          style={checked ? enabledStyle : disabledStyle}
          value={key}
          onClick={onClick.bind(null, key)}
          disabled={readonly}
        >
          {label}
        </Button>
      );
    });
  };

  const renderNot = () => {
    if (readonly && !not) {
      return null;
    }
    const id = (props as any).id;
    return (
      <Button
        key={id}
        id={id + '__not'}
        color={not ? 'primary' : 'default'}
        variant={not ? 'contained' : 'text'}
        style={not ? enabledStyle : disabledStyle}
        onClick={onNotClick.bind(null, !not)}
        disabled={readonly}
      >
        {notLabel || 'NOT'}
      </Button>
    );
  };

  return (
    <FormControl>
      <ButtonGroup disableElevation size='small' disabled={readonly}>
        {showNot && renderNot()}
        {conjsCount > 1 && !lessThenTwo && renderOptions()}
      </ButtonGroup>
    </FormControl>
  );
};
